import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, firstValueFrom, tap } from 'rxjs';
import { SystemFacade } from 'src/app/shared/system/system.facade';
import { environment } from 'src/environments/environment';
import { environment as envAlexania } from 'src/environments/environment.alexania';
import { environment as envManaus } from 'src/environments/environment.manaus';
import { environment as envETopocartNext } from 'src/environments/environment.next';
import { environment as envMesquita } from 'src/environments/environment.mesquita';
import { environment as envPortoVelho } from 'src/environments/environment.portovelho';
import { environment as envTopocartDev } from 'src/environments/environment.topocart.dev';
import { AuthFacade } from '../../store/auth/auth.facade';

@Injectable()
export class AppInitService {
  constructor(
    private systemFacade: SystemFacade,
    private router: Router,
    private authFacade: AuthFacade
  ) {}

  async init() {
    this.checkSubdomain();

    if (window.location.href.includes('/login')) {
      return;
    }

    try {
      this.systemFacade.getTenantConfig();
      const tconfig = await firstValueFrom(this.systemFacade.tenantConfig$);
      const publicTokens = await firstValueFrom(
        this.authFacade.publicTokens$.pipe(filter((p) => !!p))
      );

      const X_AUTH_TOKEN = publicTokens?.authToken;
      const X_TN_TOKEN = publicTokens?.tnToken;

      const tenantsConfigUrl = `${environment.apiUrl}tenants/config`;
      const res = await fetch(tenantsConfigUrl, {
        headers: {
          'X-AUTH-TOKEN': X_AUTH_TOKEN as string,
          'X-TN-TOKEN': X_TN_TOKEN as string,
        },
      });
      const data = await res.json();
      const config = JSON.parse(data?.config);
      const isProd = environment.production;

      const isETopocartDev = environment['isETopocartDev'];
      const isETopocartProd = environment['isETopocartProd'];
      const isNext = environment['isNext'];
      const isPortoVelho = environment['isPortoVelho'];
      const isAlexania = environment['isAlexania'];
      const isGoiania = environment['isGoiania'];
      const isManaus = environment['isManaus'];
      const isTopocartDev = environment['isTopocartDev'];

      if (!config?.cidade) {
        console.warn('[AppInit] Missing cidade in tenant config');
        return;
      }

      const cityName = config?.cidade;
      // environment.apiUrlPostgrest = `${environment.apiGatewayUrl}rest-db-${cityName}/`;

      // let apiUrlPostgrest=`https://${cityName}.${environment.postgRestUrl}`
      if (environment['isTopocart']) {
        environment.apiUrlPostgrest = environment.apiUrlPostgrest.replace(
          '<placeholder>',
          cityName
        );
        environment.apiUrlPGTiles = `${environment.apiGatewayUrl}tiles/`;
      } else {
        environment.apiUrlPostgrest = `https://${cityName}.${environment.postgRestUrl}`;
        environment.apiUrlPGTiles = `${environment.apiGatewayUrl}tiles/`;
      }

      (
        environment as any
      ).apiUrlGenericPGTiles = `${environment.apiGatewayUrl}plataforma/tiles/`;
      // environment.apiUrlPGTiles = `https://${cityName}.${environment.pgtilesUrl}`;

      // Porto Velho
      if (isPortoVelho) {
        this.setPortoVelhoEnv(cityName, isPortoVelho);
      }

      // Alexania
      if (isAlexania) {
        this.setAlexaniaEnv(cityName, isAlexania);
      }
      // Goiania
      if (isGoiania) {
        this.setAlexaniaEnv(cityName, isGoiania);
      }

      // Manaus
      if (isManaus) {
        this.setManausEnv(cityName, isManaus);
      }

      // ETOPOCART PROD
      if (isETopocartProd) {
        this.setMesquitaEnv(cityName, isETopocartProd);
      }

      // ETOPOCART DEV
      if (isNext) {
        this.setETopocartNextEnv(cityName, isNext);
      }

      // TOPOCART DEV
      if (isTopocartDev) {
        this.setTopocartDevEnv(cityName, isTopocartDev);
      }
    } catch (error) {
      console.error('[AppInit] init error', error);
    }
  }

  checkSubdomain() {
    let city: string;
    if (environment.production) {
      let site = window.location.href;
      if (site.includes('www.')) {
        site = site.replace('www.', '');
      }

      const splitSymbol = site.includes('-portal') ? '-' : '.';

      const subdomain = site.split(splitSymbol)[0];
      city = subdomain.split('//').pop() as string;

      if (city === 'portalgeo') {
        city = 'brusque';
      }

      // this.router.events
      // .pipe(
      //   filter((event) => event instanceof NavigationEnd),
      //   tap({
      //     next: ({ url }: NavigationEnd) => {
      //       if (url.includes('manutencao')) {
      //         return;
      //       }

      //       if (city === 'brusque' && url.includes('icad')) {
      //         this.router.navigate(['manutencao']);
      //       }
      //     },
      //   })
      // )
      // .subscribe();
    } else {
      let cityName: string;
      // cityName = 'ouv_test';
      // cityName = 'new_test';
      // cityName = 'portovelho';
      // cityName = 'manaus';
      // cityName = 'rincao';
      // cityName = 'parauapebas';
      // cityName = 'ibiruba';
      // cityName = 'riobranco';
      // cityName = 'santacruzdosul';
      // cityName = 'imbituba';
      // cityName = 'vitoriadaconquista';
      // cityName = 'ararangua';
      // cityName = 'chopinzinho';
      cityName = 'criciuma';
      // cityName = 'balneariocamboriu';
      // cityName = 'aparecidadegoiania';
      // cityName = 'lauromull/er';
      // cityName = 'limoeiro';
      //  cityName = 'caxiasdosul';
      // cityName = 'teresina';
      // cityName = 'brusque';
      // cityName = 'ribeiraodasneves';
      // cityName = 'portalgeo';
      // cityName = 'urussanga';
      // cityName = 'horizonte';
      // cityName = 'bnau';
      // cityName = 'imbituba';
      // cityName = 'alexania';
      // cityName = 'maracanau';
      // cityName = 'goiania'
      // cityName = 'lagarto'

      let site = `https://www.${cityName}-portal.geo360.com.br`;

      // let site = `https://www.${cityName}.brusque.sc.gov.br`;

      if (site.includes('www.')) {
        site = site.replace('www.', '');
      }
      const subdomain = site.split('-')[0];
      city = subdomain.split('//').pop() as string;

      if (city === 'portalgeo') {
        city = 'brusque';
      }

      // this.router.events
      // .pipe(
      //   filter((event) => event instanceof NavigationEnd),
      //   tap({
      //     next: ({ url }: NavigationEnd) => {
      //       if (url.includes('manutencao')) {
      //         return;
      //       }

      //       if (city === 'brusque' && url.includes('icad')) {
      //         this.router.navigate(['manutencao']);
      //       }
      //     },
      //   })
      // )
      // .subscribe();
    }
    if (!city) {
      this.router.navigate(['not-found', city]);
      return;
    }
    this.authFacade.getPublicTokens(city);
  }

  setETopocartNextEnv(cityName: string, isETopocartNext: boolean) {
    const cityPostgREST = envETopocartNext.apiUrlPostgrest.replace(
      '<placeholder>',
      cityName
    );

    environment.apiUrlPostgrest = isETopocartNext
      ? cityPostgREST
      : environment.apiUrlPostgrest;

    environment.apiUrlPGTiles = `${environment.apiGatewayUrl}tiles/`;
  }

  setMesquitaEnv(cityName: string, isETopocartProd: boolean) {
    const cityPostgREST = envMesquita.apiUrlPostgrest.replace(
      '<placeholder>',
      cityName
    );

    environment.apiUrlPostgrest = isETopocartProd
      ? cityPostgREST
      : environment.apiUrlPostgrest;

    environment.apiUrlPGTiles = `${environment.apiGatewayUrl}tiles/`;
  }

  setPortoVelhoEnv(cityName: string, isPortoVelho: boolean) {
    const cityPostgREST = envPortoVelho.apiUrlPostgrest.replace(
      '<placeholder>',
      cityName
    );

    environment.apiUrlPostgrest = isPortoVelho
      ? cityPostgREST
      : environment.apiUrlPostgrest;

    environment.apiUrlPGTiles = `${environment.apiGatewayUrl}tiles/`;
  }

  setAlexaniaEnv(cityName: string, isAlexania: boolean) {
    const cityPostgREST = envAlexania.apiUrlPostgrest.replace(
      '<placeholder>',
      cityName
    );

    environment.apiUrlPostgrest = isAlexania
      ? cityPostgREST
      : environment.apiUrlPostgrest;

    environment.apiUrlPGTiles = `${environment.apiGatewayUrl}tiles/`;
  }

  setManausEnv(cityName: string, isManaus: boolean) {
    const cityPostgREST = envManaus.apiUrlPostgrest.replace(
      '<placeholder>',
      cityName
    );

    environment.apiUrlPostgrest = isManaus
      ? cityPostgREST
      : environment.apiUrlPostgrest;

    environment.apiUrlPGTiles = `${environment.apiGatewayUrl}tiles/`;
  }

  setTopocartDevEnv(cityName: string, isTopocartDev: boolean) {
    const cityPostgREST = envTopocartDev.apiUrlPostgrest.replace(
      '<placeholder>',
      cityName
    );

    environment.apiUrlPostgrest = isTopocartDev
      ? cityPostgREST
      : environment.apiUrlPostgrest;

    environment.apiUrlPGTiles = `${environment.apiGatewayUrl}tiles/`;
  }
}
